export const OFFER_PURCHASE_WINDOWS = [
  { minutes: 30, label: '30 minutes' },
  { minutes: 60, label: '1 hour' },
  { minutes: 360, label: '6 hours' },
  { minutes: 720, label: '12 hours' },
  { minutes: 1440, label: '24 hours' },
] as const;

export type OfferPurchaseWindowMinutes = (typeof OFFER_PURCHASE_WINDOWS)[number]['minutes'];

export function labelForPurchaseWindow(minutes: number): string {
  const hit = OFFER_PURCHASE_WINDOWS.find((w) => w.minutes === minutes);
  return hit?.label || `${minutes} minutes`;
}

export function isListingOnHold(listing: { hold_until?: string | null } | null | undefined, now = Date.now()): boolean {
  if (!listing?.hold_until) return false;
  const t = new Date(listing.hold_until).getTime();
  return Number.isFinite(t) && t > now;
}

export function holdMsRemaining(holdUntil?: string | null, now = Date.now()): number {
  if (!holdUntil) return 0;
  const t = new Date(holdUntil).getTime();
  if (!Number.isFinite(t)) return 0;
  return Math.max(0, t - now);
}

export function formatCountdown(ms: number): string {
  if (ms <= 0) return '0:00';
  const totalSec = Math.ceil(ms / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const mins = Math.floor((totalSec % 3600) / 60);
  const secs = totalSec % 60;
  if (days > 0) return `${days}d ${hours}h ${mins}m`;
  if (hours > 0) return `${hours}h ${mins}m ${secs}s`;
  return `${mins}:${String(secs).padStart(2, '0')}`;
}
